export const EVENTS_DEPARTMENT = {
    FETCH_DEPARTMENT_AGAIN: "DEPARTMENT.FETCH_DEPARTMENT_AGAIN"
}
